import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IRealEstateProject, ITariffIncreasePlan } from './interfaces';

export const BASE_URL = '/dictionary/tariffIncreasePlan';

export const getTariffIncreasePlanList = (data: IDynamicTableParams) => {
  return instance()
    .post<ITariffIncreasePlan[]>(`${BASE_URL}/list`, data)
    .then((response) => response.data);
};

export const getTariffIncreasePlanAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`${BASE_URL}/availableColumns`)
    .then((response) => response.data);
};

export const getTariffIncreasePlanAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`${BASE_URL}/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadTariffIncreasePlan = (tariffIncreasePlanId: number) => {
  return instance()
    .get<ITariffIncreasePlan>(`${BASE_URL}/load/${tariffIncreasePlanId}`)
    .then((response) => response.data);
};

export const createTariffIncreasePlan = (tariffIncreasePlan: ITariffIncreasePlan) => {
  return instance()
    .post(`${BASE_URL}/save`, tariffIncreasePlan)
    .then((response) => response.data);
};

export const updateTariffIncreasePlan = (tariffIncreasePlanId: number, tariffIncreasePlan: ITariffIncreasePlan) => {
  return instance()
    .post(`${BASE_URL}/${tariffIncreasePlanId}/update`, tariffIncreasePlan)
    .then((response) => response.data);
};

export const archiveTariffIncreasePlan = (tariffIncreasePlanId: number) => {
  return instance()
    .post(`${BASE_URL}/${tariffIncreasePlanId}/delete`)
    .then((response) => response.data);
};

export const recoverTariffIncreasePlan = (tariffIncreasePlanId: number) => {
  return instance()
    .post(`${BASE_URL}/${tariffIncreasePlanId}/recover`)
    .then((response) => response.data);
};

// Блок-проекты для выбора в диалоге: тот же справочник, по которому ГПР считает дату события.
export const getRealEstateProjects = () => {
  return instance()
    .get<IRealEstateProject[]>('/realEstate/project/list')
    .then((response) => response.data);
};
